import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CryptoBalancePipe } from '@libs/pipes/wallet/crypto.balance.pipe';
import { IconComponent } from '@libs/stand-alone-components/commons/icon/icon.component';
import { WalletService } from '@libs/app.services/wallet/wallet.service';
import { StoreWalletService } from '@libs/app.services/store/store-wallet.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-wallet-row',
  templateUrl: './wallet-row.component.html',
  styleUrls: ['./wallet-row.component.scss'],

  imports: [CommonModule, IconComponent, CryptoBalancePipe],
})
export class WalletRowComponent {
  type = input<'simple' | 'complete'>();
  isOpen = input<boolean>();
  onoverlay = output<void>();
  wallet = computed(() => this.walletService.wallet());
  balance$: Observable<number> = this.storeWalletService.selectBalance().pipe(
    tap(() => this.onNewBalance.set(true)),
    tap(() => setTimeout(() => this.onNewBalance.set(false), 400)),
  );
  onNewBalance = signal<boolean>(false);
  balance = toSignal(this.balance$);
  constructor(
    private walletService: WalletService,
    private storeWalletService: StoreWalletService,
  ) {}

  toggle() {
    this.onoverlay.emit();
  }
}
